import type { Snapshot } from '../types';
import { classColor } from '../lib/wow';

interface Props {
  snapshot: Snapshot;
}

export function TalentSummary({ snapshot }: Props) {
  const tabs = snapshot.talents?.tabs || {};
  const color = classColor(snapshot.profile.classFile);
  const tabEntries = Object.entries(tabs).sort((a, b) => Number(a[0]) - Number(b[0]));

  const distribution = tabEntries.map(([_, tab]) => tab.pointsSpent ?? 0);
  const total = distribution.reduce((sum, n) => sum + n, 0);

  return (
    <div className="talents">
      <h3>Talents</h3>
      <div className="talent-distribution" style={{ borderColor: color }}>
        {tabEntries.map(([id, tab]) => (
          <div key={id} className="talent-tab">
            <div className="talent-tab-name">{tab.name}</div>
            <div className="talent-tab-points" style={{ color }}>
              {tab.pointsSpent || 0}
            </div>
          </div>
        ))}
      </div>
      <div className="talent-total">
        {total} points spent
        {snapshot.talents?.unspent ? ` (${snapshot.talents.unspent} unspent)` : ''}
      </div>
    </div>
  );
}
